import type {
  IncentiveProgramEntity,
  NewIncentiveProgramEntity,
  PreviousIncentiveSummaryEntity,
} from "@features/dynamic-incentives/domain";
import type {
  IncentiveProgramModel,
  NewIncentiveProgramModel,
  PreviousIncentiveSummaryModel,
} from "../models";

/**
 * Map incentive program model to entity
 */
export function mapIncentiveProgram(
  model: IncentiveProgramModel,
): IncentiveProgramEntity {
  return {
    currentIncentive: model.currentIncentive
      ? mapNewIncentiveProgram(model.currentIncentive)
      : undefined,
    prevIncentiveSummary: model.prevIncentiveSummary
      ? mapPreviousIncentiveSummary(model.prevIncentiveSummary)
      : undefined,
  };
}

/**
 * Map new incentive program model to entity
 */
function mapNewIncentiveProgram(
  model: NewIncentiveProgramModel,
): NewIncentiveProgramEntity {
  return {
    ...model,
    nextIncentiveProgramDate: new Date(model.nextIncentiveProgramDate),
    startDate: new Date(model.startDate),
    endDate: new Date(model.endDate),
    deliveryCalculationDate: new Date(model.deliveryCalculationDate),
    renewalDate: new Date(model.renewalDate),
  };
}

/**
 * Map previous incentive summary model to entity
 */
function mapPreviousIncentiveSummary(
  model: PreviousIncentiveSummaryModel,
): PreviousIncentiveSummaryEntity {
  return {
    ...model,
    startDate: new Date(model.startDate),
    endDate: new Date(model.endDate),
    deliveryCalculationDate: new Date(model.deliveryCalculationDate),
  };
}
